import Cookies from "js-cookie";
import { LoginRequest } from "../models/auth/LoginRequest";
import { LoginResponse } from "../models/auth/LoginResponse";
import { BaseService } from "./BaseService";

export class AuthService  extends BaseService {
    public async Login(loginRequest: LoginRequest) {
        const loginResponse = await this.Post<LoginResponse>("/login", loginRequest);
        
        // Store the authentication token in cookies
        if (loginResponse.id_token) {
            Cookies.set("User.Identity", loginResponse.id_token, { 
                expires: 7, // 7 days
                secure: true,
                sameSite: 'strict'
            });
        }
        
        return loginResponse;
    }
}


export const authService = new AuthService("auth");